
export default function block_toys() {
  if ($('.felds-toys-block').length == 0) return;

  $('.felds-toys-block .block-filter button').click(function (e) {
    e.preventDefault();
    
    var params = '';

    var filter_search = $('.felds-toys-block .block-filter #filter-search').val();
    if (filter_search) {
      params = '?filter_search=' + filter_search;
    }

    location = $('.felds-toys-block .block-filter').data('url') + params;
  });

}
